<template>
  <div class="navbar-bookmarks flex items-center">
    <!-- STARRED PAGES - FIRST 10 -->
    <!-- <ul class="vx-navbar__starred-pages">
      <draggable v-model="starredPagesLimited" :group="{name: 'pinList'}" class="flex cursor-move">
        <li class="starred-page" v-for="page in starredPagesLimited" :key="page.url">
          <vx-tooltip :text="page.title" position="bottom" delay=".3s">
            <feather-icon :svgClasses="['h-6 w-6 stroke-current', textColor]" class="p-2 cursor-pointer" :icon="page.icon" @click="$router.push(page.url).catch(() => {})" />
          </vx-tooltip>
        </li>
      </draggable>
    </ul> -->

    <!-- STARRED PAGES MORE -->
    <div class="vx-navbar__starred-pages--more-dropdown" v-if="starredPagesMore.length">
      <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="cursor-pointer p-2"></feather-icon>
        <vs-dropdown-menu>
          <ul class="vx-navbar__starred-pages-more--list">
            <draggable v-model="starredPagesMore" :group="{name: 'pinList'}" class="cursor-move">
              <li class="starred-page--more flex items-center cursor-pointer" v-for="page in starredPagesMore" :key="page.url" @click="$router.push(page.url).catch(() => {})">
                <feather-icon class="ml-2 mr-1" :icon="page.icon" :svgClasses="['h-5 w-5 stroke-current', textColor]"></feather-icon>
                <span class="px-2 pt-2 pb-1">{{ page.title }}</span>
              </li>
            </draggable>
          </ul>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>

    <div class="bookmark-container">
      <!-- <feather-icon icon="StarIcon" :svgClasses="['stoke-current text-warning', textColor]" class="cursor-pointer p-2" @click.stop="showBookmarkPagesDropdown = !showBookmarkPagesDropdown" /> -->
      <h4 class="flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40" fill="none">
          <path d="M20.2139 35.7143C13.801 35.7143 8.13949 31.803 5.78772 25.7485C5.57357 25.2 5.84113 24.5771 6.38372 24.36C6.92477 24.1458 7.54064 24.4129 7.75479 24.9658C9.78534 30.193 14.6762 33.5715 20.2139 33.5715C27.5945 33.5715 33.6002 27.4827 33.6002 20.0001C33.6002 12.5174 27.5945 6.42861 20.2139 6.42861C14.6762 6.42861 9.78534 9.80715 7.75479 15.0343C7.5391 15.5872 6.92477 15.8543 6.38372 15.6401C5.84113 15.423 5.57357 14.8001 5.78772 14.2516C8.13949 8.19714 13.801 4.28577 20.2139 4.28577C28.76 4.28577 35.7139 11.3358 35.7139 20.0001C35.7139 28.6643 28.76 35.7143 20.2139 35.7143Z" fill="rgba(var(--vs-primary), 1)"/>
          <ellipse cx="21.4284" cy="14.2857" rx="2.85714" ry="2.85714" fill="rgba(var(--vs-primary), 1)"/>
          <path d="M15.7139 24.2857C15.7139 21.1298 18.2722 18.5714 21.4282 18.5714V18.5714C24.5841 18.5714 27.1424 21.1298 27.1424 24.2857V26.3636C27.1424 26.794 26.7936 27.1428 26.3632 27.1428H16.4931C16.0627 27.1428 15.7139 26.794 15.7139 26.3636V24.2857Z" fill="rgba(var(--vs-primary), 1)"/>
          <path d="M13.4149 20H2.29968C1.81891 20 1.42871 19.68 1.42871 19.2857C1.42871 18.8914 1.81891 18.5714 2.29968 18.5714H13.4149C13.8957 18.5714 14.2859 18.8914 14.2859 19.2857C14.2859 19.68 13.8957 20 13.4149 20Z" fill="rgba(var(--vs-primary), 1)"/>
          <path d="M9.35025 24.2858C9.15071 24.2858 8.95135 24.2091 8.79956 24.0543C8.4952 23.746 8.4952 23.2461 8.79956 22.9376L12.4045 19.2858L8.79956 15.6338C8.4952 15.3254 8.4952 14.8253 8.79956 14.517C9.1041 14.2087 9.59754 14.2087 9.9019 14.517L14.0573 18.7269C14.3617 19.0352 14.3617 19.5351 14.0573 19.8435L9.9019 24.0532C9.74915 24.2091 9.54979 24.2858 9.35025 24.2858V24.2858Z" fill="rgba(var(--vs-primary), 1)"/>
        </svg> 
        <span style="font-size: 14px;font-weight: 700;color: rgba(var(--vs-primary), 1)">{{cutomerName}}</span>
      </h4>
      <div v-click-outside="outside" class="absolute bookmark-list w-1/3 xl:w-1/4 mt-4" v-if="showBookmarkPagesDropdown">
        <vx-auto-suggest
          ref="bookmarkAutoSuggest"
          :autoFocus="true"
          :data="navbarSearchAndPinList"
          :initalData="{pages: starredPagesLimited.concat(starredPagesMore)}"
          :searchLimit="5"
          placeholder="Explore Vuexy..."
          inputClassses="w-full"
          show-action
          show-pinned
          hideGroupTitle
          background-overlay
          @input="hnd_search_query_update"
          @selected="selected">

          <!-- Pages Suggestion -->
          <template v-slot:pages="{ suggestion }">
            <div class="flex items-center justify-between">
              <div class="flex items-end leading-none py-1">
                <feather-icon :icon="suggestion.icon" svgClasses="h-5 w-5" class="mr-4" />
                <span class="mt-1">{{ suggestion.title }}</span>
              </div>
              <feather-icon
                icon="StarIcon"
                :svgClasses="[{'text-warning': suggestion.is_bookmarked}, 'h-5 w-5 stroke-current mt-1']"
                @click.stop="actionClicked(suggestion)" />
            </div>
          </template>

        </vx-auto-suggest>
      </div>
    </div>
  </div>
</template>

<script>
import draggable     from 'vuedraggable'
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'

export default {
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    draggable,
    VxAutoSuggest
  },
  data () {
    return {
      showBookmarkPagesDropdown : false,
      cutomerName: JSON.parse(localStorage.getItem('customer_name'))
    }
  },
  watch: {
    '$route' () {
      if (this.showBookmarkPagesDropdown) this.showBookmarkPagesDropdown = false
    }
  },
  computed: {
    navbarSearchAndPinList () {
      return {pages: this.$store.state.navbarSearchAndPinList['pages']}
    },
    starredPages () {
      return this.$store.state.starredPages
    },
    starredPagesLimited: {
      get () {
        return this.starredPages.slice(0, 10)
      },
      set (list) {
        this.$store.dispatch('arrangeStarredPagesLimited', list)
      }
    },
    starredPagesMore: {
      get () {
        return this.starredPages.slice(10)
      },
      set (list) {
        this.$store.dispatch('arrangeStarredPagesMore', list)
      }
    },
    textColor () {
      return {'text-white': this.$store.state.mainLayoutType === 'vertical' && this.navbarColor !== (this.$store.state.theme === 'dark' ? '#10163a' : '#fff') }
    }
  },
  methods: {
    selected (obj) {
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', false)
      this.showBookmarkPagesDropdown = false
      this.$router.push(obj.pages.url).catch(() => {})
    },
    actionClicked (item) {
      this.$store.dispatch('updateStarredPage', { url: item.url, val: !item.is_bookmarked })
      // this.$refs.bookmarkAutoSuggest.filterData()
    },
    outside () {
      this.showBookmarkPagesDropdown = false
    },
    hnd_search_query_update (query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY', !!query)
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || !el.contains(e.target) && el !== e.target) {
          /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}

</script>
